export class CategoryApiModel {
  constructor(
    public id: string | null = null,
    public name: string | null = null,
    public categoryPriorityOrder: number | null = null,
    public contactGroup: string | null = null,
    public description: string | null = null,
  ) {}
}
